"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nutrients = void 0;
var React = require("react");
var react_1 = require("react");
var state_1 = require("../compare/state");
var _ = require("lodash");
var obligatoryNutrients = ["ENERC_KJ", "ENERC_KCAL", "PROCNT", "FAT", "FASAT", "CHO-", "SUGAR", "NACL"];
var Nutrients = function () {
    var state = (0, state_1.useStateValue)().state;
    var nutrients = state.nutrients, products = state.products;
    var _a = (0, react_1.useState)(false), showAllNutrients = _a[0], setShowAllNutrients = _a[1];
    var _b = (0, react_1.useState)("Vis mer..."), moreNutrientsLinkText = _b[0], setmoreNutrientsLinkText = _b[1];
    var nutrientRef = (0, react_1.useRef)(null);
    var filterNutrients = function (nutrients) {
        return showAllNutrients ? nutrients : nutrients.filter(function (f) { return obligatoryNutrients.some(function (o) { return o === f.code; }); });
    };
    var getNutrientValue = function (products, code) {
        var nutrientValue = products.map(function (product, index) {
            var nutrient = _.find(product.nutrients, function (n) { return n.code === code; });
            return React.createElement("td", { key: index, style: { width: "".concat(100 / products.length, "%") } }, nutrient ? "".concat(nutrient.measurement, " ").concat(nutrient.measurementType) : "Ikke oppgitt");
        });
        return nutrientValue;
    };
    var getNutrientsRows = function (nutrients, products) {
        var nutrientRows = filterNutrients(nutrients).sort(function (a, b) { return a.order >= b.order ? 1 : -1; }).map(function (nutrient) {
            return React.createElement(React.Fragment, { key: nutrient.code },
                React.createElement("tr", null,
                    React.createElement("td", { className: "nutrient-info", colSpan: 3 },
                        React.createElement("strong", null, nutrient.name))),
                React.createElement("tr", { className: "nutrient-value" }, getNutrientValue(products, nutrient.code)));
        });
        return nutrientRows;
    };
    var hasNutrients = function (products) {
        var hasNutrient = false;
        products.forEach(function (p) {
            if (p.nutrients.length > 0)
                hasNutrient = true;
        });
        return hasNutrient;
    };
    var getNutrientContent = function (products) {
        return (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Pr. 100 gram."),
            React.createElement("h2", { className: "top" }, "N\u00E6ringsinnhold"),
            React.createElement("table", { className: "div-table" },
                React.createElement("tbody", null, getNutrientsRows(nutrients, products))),
            React.createElement("a", { href: "#", "data-testid": "more-nutrients-link", onClick: showMore, className: "link link-underlined" }, moreNutrientsLinkText)));
    };
    var getNutrientSection = function (nutrients, products) {
        return React.createElement("div", { className: "nutrient-section", ref: nutrientRef }, getNutrientContent(products));
    };
    var showMore = function (e) {
        e.preventDefault();
        if (showAllNutrients) {
            setmoreNutrientsLinkText("Vis mer...");
            window.scrollTo(0, nutrientRef.current.offsetTop);
        }
        else {
            setmoreNutrientsLinkText("Vis mindre...");
        }
        setShowAllNutrients(!showAllNutrients);
    };
    return (React.createElement("div", { className: "row" }, getNutrientSection(nutrients, products)));
};
exports.Nutrients = Nutrients;
